/* unplugin-vue-components disabled */import { render } from "./projectlist.vue?vue&type=template&id=7e7531dc"
import script from "./projectlist.vue?vue&type=script&lang=js"
export * from "./projectlist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__